import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Pixelify_Sans\",\"arguments\":[{\"weight\":[\"400\",\"700\",\"500\"],\"preload\":false}],\"variableName\":\"pixelify\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Providers/index.tsx");
